import GemMeterBaseRule from '../GemMeterBaseRule';
import { NO_SOURCE_VIDEO } from '../../../constants/rulesConstants';

export default class MissingPopupLinkRule extends GemMeterBaseRule {
  static ruleId = NO_SOURCE_VIDEO.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return true;
    }

    const hrefAttr = element.getAttribute('href')!;

    return !!(hrefAttr && hrefAttr.trim().length > 1);
  }
}
